define(function(require, exports, module) {
    var tplModel = {
        render: function(data, tpl) {
            var render = template.compile(tpl.tpl);
            return render(data);
        }
    };
    module.exports = tplModel;
});


// WEBPACK FOOTER //
// ./src/js/model/tplModel/tplModel.js